<template>
  <el-dialog :visible.sync="open" title="Link event">
    <el-form label-width="140px" @keyup.enter.native="update" >
      <el-form-item label="Event">
        <el-select v-model='event' placeholder='Select' filterable>
          <el-option v-for='event in events' :key='event.id' :label='event.alias' :value='event.id' />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer" >
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="update">{{ $t('common.save') }}</el-button>
    </span>

  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['open'],
  data () {
    return {
      lang: 'fr',
      event: null,
      eventSelected: null
    }
  },
  computed: {
    ...mapGetters('events', {
      events: 'events'
    })
  },
  watch: {
    event () {
      this.events.forEach((evt) => {
        if (this.event === evt.id) {
          this.eventSelected = evt
        }
      })
    }
  },
  methods: {
    ...mapActions('events', ['loadEvents']),

    close () {
      this.$emit('close')
    },
    update () {
      this.$emit('event', this.eventSelected)
      this.close()
    }

  },
  mounted () {
    this.loadEvents()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LinkEvent.vue